<template>
  <div>
    <b-row class="match-height">
      <b-col
        lg="12"
        xl="12"
      >
        <Flooding-Way />
      </b-col>
      <b-col
        lg="8"
        xl="8"
        class="mt-1"
      >
        <Flooding-CCTV />
        <!-- <Flooding /> -->
      </b-col>
      <b-col
        class="mt-1"
        lg="4"
        xl="4"
      >
        <Flooding-Table />
      </b-col>
    </b-row>
  </div>

</template>

<script>
import {
  BRow, BCol,
} from 'bootstrap-vue'
import FloodingWay from '@/views/flooding/detail/FloodingWay.vue'
import FloodingCCTV from '@/views/flooding/detail/FloodingCCTV.vue'
import FloodingTable from '@/views/flooding/detail/FloodingTable.vue'
// import Flooding from '@/views/flooding/detail/Flooding.vue'
// import axios from '@axios'
export default {
  components: {
    BRow,
    BCol,
    FloodingWay,
    // Flooding,
    FloodingTable,
    FloodingCCTV,
  },
  data() {
    return {
    }
  },
  mounted() {
    this.$store.commit('verticalMenu/UPDATE_VERTICAL_MENU_COLLAPSED', true)
  },
  methods: {
  },
}
</script>

  <style>
  </style>
